import React, { useEffect, useState } from 'react';
import { Badge, Dropdown, List, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import axios from 'axios';

const NotificationsBell = () => {
    const [items, setItems] = useState([]);
    const [open, setOpen] = useState(false);

    const load = async () => {
        try {
            const res = await axios.get('/v1/notifications');
            setItems(res.data?.data || []);
        } catch (e) {}
    };

    useEffect(() => {
        load();
    }, []);

    const unreadCount = items.filter(i => !i.read_at).length;

    const markRead = async (id) => {
        try {
            await axios.post(`/v1/notifications/${id}/read`);
            await load();
        } catch (e) {}
    };

    const menu = (
        <div style={{ width: 320, maxHeight: 360, overflowY: 'auto', padding: 8 }}>
            <List
                dataSource={items}
                locale={{ emptyText: 'No notifications' }}
                renderItem={(it) => (
                    <List.Item actions={[!it.read_at ? <Button size="small" type="link" onClick={() => markRead(it.id)}>Mark read</Button> : null]}>
                        <List.Item.Meta
                            title={<span>{it.type}</span>}
                            description={<span>{new Date(it.created_at).toLocaleString()}</span>}
                        />
                    </List.Item>
                )}
            />
        </div>
    );

    return (
        <Dropdown popupRender={() => menu} trigger={['click']} open={open} onOpenChange={setOpen}>
            <Badge count={unreadCount} size="small">
                <Button type="text" icon={<BellOutlined />} />
            </Badge>
        </Dropdown>
    );
};

export default NotificationsBell;
